module.exports = __webpack_public_path__ + "img/infographic-jiso.9d3beb28.jpg";